export default __webpack_public_path__ + "static/w-paper-ecb660c25c223fdc6aec6cf8cf5daf70.svg";